export default class Core {
  static entity = {}
  static text = {}
  static buttons = {}
  static display = {}
  static win = {}
}

import BetField from 'core/components/bet/BetField'
import ParticleSignals from 'core/components/particles/ParticleSignals'
import SingleWinParticle from 'core/components/particles/SingleWinParticle'
import WinParticle from 'core/components/particles/WinParticle'
import BaseReel from 'core/components/reels/BaseReel'
import CascadeReel from 'core/components/reels/CascadeReel'
import ExplosionReel from 'core/components/reels/ExplosionReel'
import HorizontalReel from 'core/components/reels/HorizontalReel'
import OverSymbolReel from 'core/components/reels/OverSymbolReel'
import SlideReel from 'core/components/reels/SlideReel'
import BigWinCounter from 'core/components/wins/BigWinCounter'
import BigWinTitle from 'core/components/wins/BigWinTitle'
import BonusImage from 'core/display/BonusImage'
import AutoButton from 'core/display/buttons/AutoButton'
import BetButton from 'core/display/buttons/BetButton'
import DecreaseAutoButton from 'core/display/buttons/DecreaseAutoButton'
import DecreaseBetButton from 'core/display/buttons/DecreaseBetButton'
import DecreasePageButton from 'core/display/buttons/DecreasePageButton'
import GraphicsButton from 'core/display/buttons/GraphicsButton'
import ImageButton from 'core/display/buttons/ImageButton'
import IncreaseAutoButton from 'core/display/buttons/IncreaseAutoButton'
import IncreaseBetButton from 'core/display/buttons/IncreaseBetButton'
import IncreasePageButton from 'core/display/buttons/IncreasePageButton'
import MaxBetButton from 'core/display/buttons/MaxBetButton'
import NextHistoryButton from 'core/display/buttons/NextHistoryButton'
import { makePopupButton } from 'core/display/buttons/PopupButton'
import PrevHistoryButton from 'core/display/buttons/PrevHistoryButton'
import RadioButton from 'core/display/buttons/RadioButton'
import ReverseToggleButton from 'core/display/buttons/ReverseToggleButton'
import SpinButton from 'core/display/buttons/SpinButton'
import SpinSwipeButton from 'core/display/buttons/SpinSwipeButton'
import ToggleButton from 'core/display/buttons/ToggleButton'
import ChoiceImage from 'core/display/ChoiceImage'
import makeAnimationSpine from 'core/display/composite/AnimationSpine'
import makeCascadeMultiplierSpine from 'core/display/composite/CascadeMultiplierSpine'
import makeLogoSpine from 'core/display/composite/LogoSpine'
import NoiseGraphics from 'core/display/composite/NoiseGraphics'
import ReplaceText from 'core/display/composite/ReplaceText'
import BookAnimationContainer from 'core/display/context/animation/BookAnimation'
import BookFsReel from 'core/display/context/animation/BookFsReel'
import makeReplaceTriggerSpine from 'core/display/context/animation/ReplaceTriggerSpine'
import makeTriggerSpine from 'core/display/context/animation/TriggerSpine'
import AutoCarousel from 'core/display/context/AutoCarousel'
import BetCarousel from 'core/display/context/BetCarousel'
import BookSymbol from 'core/display/context/BookSymbol'
import BuyBetCarousel from 'core/display/context/BuyBetCarousel'
import PageCarousel from 'core/display/context/PageCarousel'
import SymbolValuePopup from 'core/display/context/SymbolValuePopup'
import AutoCountText from 'core/display/context/texts/AutoCountText'
import AutoLimitOptionText from 'core/display/context/texts/AutoLimitOptionText'
import AutoLimitSelectedText from 'core/display/context/texts/AutoLimitSelectedText'
import BalanceText from 'core/display/context/texts/BalanceText'
import BalanceTextCurrency from 'core/display/context/texts/BalanceTextCurrency'
import BetText from 'core/display/context/texts/BetText'
import BetTextCurrency from 'core/display/context/texts/BetTextCurrency'
import BitmapBaseValue from 'core/display/context/texts/BitmapBaseValue'
import BitmapWinText from 'core/display/context/texts/BitmapWinText'
import ButtonBetText from 'core/display/context/texts/ButtonBetText'
import CascadeCurrentWinText from 'core/display/context/texts/CascadeCurrentWinText'
import CascadeTotalWinText from 'core/display/context/texts/CascadeTotalWinText'
import ClockText from 'core/display/context/texts/ClockText'
import FreeBetCountText from 'core/display/context/texts/FreeBetCountText'
import FreeBetLeft from 'core/display/context/texts/FreeBetLeft'
import FreeBetText from 'core/display/context/texts/FreeBetText'
import FreeBetWinText from 'core/display/context/texts/FreeBetWinText'
import FreespinsAddText from 'core/display/context/texts/FreespinsAddText'
import FreespinsCountText from 'core/display/context/texts/FreespinsCountText'
import FreespinsTotalWinPopupText from 'core/display/context/texts/FreespinsTotalWinPopupText'
import FreespinsTotalWinPopupTextCurrency from 'core/display/context/texts/FreespinsTotalWinPopupTextCurrency'
import FreespinsTotalWinText from 'core/display/context/texts/FreespinsTotalWinText'
import FreespinsTotalWinTextCurrency from 'core/display/context/texts/FreespinsTotalWinTextCurrency'
import LineWinText from 'core/display/context/texts/LineWinText'
import LineWinTextCurrency from 'core/display/context/texts/LineWinTextCurrency'
import NetPositionText from 'core/display/context/texts/NetPosition'
import PayoutText from 'core/display/context/texts/PayoutText'
import PayoutTextCurrency from 'core/display/context/texts/PayoutTextCurrency'
import PopupText from 'core/display/context/texts/PopupText'
import RTPText from 'core/display/context/texts/RTPText'
import TimerText from 'core/display/context/texts/TimerText'
import WinText from 'core/display/context/texts/WinText'
import WinTextCurrency from 'core/display/context/texts/WinTextCurrency'
import AutomenuEntity from 'core/display/entities/AutomenuEntity'
import BetEntity from 'core/display/entities/BetEntity'
import { makeCheatEntity } from 'core/display/entities/CheatEntity'
import FreespinsEndEntity from 'core/display/entities/FreespinsEndEntity'
import FreespinsStartEntity from 'core/display/entities/FreespinsStartEntity'
import FullscreenEntity from 'core/display/entities/FullscreenEntity'
import GameRulesEntity from 'core/display/entities/GameRulesEntity'
import HistoryEntity from 'core/display/entities/HistoryEntity'
import IntroScreenEntity from 'core/display/entities/IntroScreenEntity'
import LinesEntity from 'core/display/entities/LinesEntity'
import MenuBackEntity from 'core/display/entities/MenuBackEntity'
import MenuEntity from 'core/display/entities/MenuEntity'
import MenuEntityBg from 'core/display/entities/MenuEntityBg'
import PaytableEntity from 'core/display/entities/PaytableEntity'
import PaytablePageEntity from 'core/display/entities/PaytablePageEntity'
import CascadeEntity from 'core/display/entities/reels/CascadeEntity'
import ExplosionReelsEntity from 'core/display/entities/reels/ExplosionReelsEntity'
import FoodReelsEntity from 'core/display/entities/reels/FoodReelsEntity'
import OverReelEntity from 'core/display/entities/reels/OverReelEntity'
import ReelsEntity from 'core/display/entities/reels/ReelsEntity'
import VolcanReelsEntity from 'core/display/entities/reels/VolcanReelsEntity'
import SettingsEntity from 'core/display/entities/SettingsEntity'
import SoundPopupEntity from 'core/display/entities/SoundPopupEntity'
import TextLineEntity from 'core/display/entities/TextLineEntity'
import UIGeneralEntity from 'core/display/entities/UIGeneralEntity'
import UIRegularEntity from 'core/display/entities/UIRegularEntity'
import WinAnimationEntity from 'core/display/entities/WinAnimationEntity'
import Image from 'core/display/Image'
import NineSlicePlane from 'core/display/NineSlicePlane'
import Particle from 'core/display/Particle'
import makeContainer from 'core/display/simple/Container'
import makeGraphics from 'core/display/simple/Graphics'
import TextCreate from 'core/display/simple/Text'
import BonusAnimation from 'core/display/spines/BonusAnimation'
import BonusMultiplierSpine from 'core/display/spines/BonusMultiplierSpine'
import BonusNameSpine from 'core/display/spines/BonusNameSpine'
import BonusTwoAnimation from 'core/display/spines/BonusTwoAnimation'
import CascadeWinBox from 'core/display/spines/CascadeWinBox'
import ChooseSpinePopup from 'core/display/spines/ChooseSpinePopup'
import GambleSpine from 'core/display/spines/gamble/GambleSpine'
import OverReelAnimation from 'core/display/spines/OverReelAnimation'
import TransitionAnimation from 'core/display/spines/TransitionAnimation'
import WinSpine from 'core/display/spines/WinSpine'
import VideoContainer from 'core/display/VideoContainer'
import BaseLottery from 'logic/module/lottery/BaseViewLottery'

//entity

Core.entity.TextLineEntity = TextLineEntity
Core.entity.AutoMenuEntity = AutomenuEntity
Core.entity.FreespinsStartEntity = FreespinsStartEntity
Core.entity.FreespinsEndEntity = FreespinsEndEntity
Core.entity.BetEntity = BetEntity
Core.entity.CheatEntity = makeCheatEntity
Core.entity.FullscreenEntity = FullscreenEntity
Core.entity.GameRulesEntity = GameRulesEntity
Core.entity.HistoryEntity = HistoryEntity
Core.entity.IntroScreenEntity = IntroScreenEntity
Core.entity.LinesEntity = LinesEntity
Core.entity.MenuBackEntity = MenuBackEntity
Core.entity.MenuEntity = MenuEntity
Core.entity.MenuEntityBg = MenuEntityBg
Core.entity.PaytableEntity = PaytableEntity
Core.entity.PaytablePageEntity = PaytablePageEntity
Core.entity.ExplosionReelsEntity = ExplosionReelsEntity
Core.entity.FoodReelsEntity = FoodReelsEntity
Core.entity.OverReelEntity = OverReelEntity
Core.entity.ReelsEntity = ReelsEntity
Core.entity.VolcanReelsEntity = VolcanReelsEntity
Core.entity.SettingsEntity = SettingsEntity
Core.entity.SoundPopupEntity = SoundPopupEntity
Core.entity.WinAnimationEntity = WinAnimationEntity
Core.entity.UIRegularEntity = UIRegularEntity
Core.entity.UIGeneralEntity = UIGeneralEntity
Core.entity.CascadeEntity = CascadeEntity

// Text

Core.text.ReplaceText = ReplaceText
Core.text.CascadeTotalWinText = CascadeTotalWinText
Core.text.CascadeCurrentWinText = CascadeCurrentWinText
Core.text.Text = TextCreate
Core.text.HistoryText = TextCreate
Core.text.FreespinsTotalWinTextCurrency = FreespinsTotalWinTextCurrency
Core.text.AutoCountText = AutoCountText
Core.text.AutoLimitOptionText = AutoLimitOptionText
Core.text.AutoLimitSelectedText = AutoLimitSelectedText
Core.text.BetText = BetText
Core.text.ButtonBetText = ButtonBetText
Core.text.ClockText = ClockText
Core.text.TimerText = TimerText
Core.text.FreespinsAddText = FreespinsAddText
Core.text.FreespinsCountText = FreespinsCountText
Core.text.PopupText = PopupText
Core.text.RtpText = RTPText
Core.text.FreeBetCountText = FreeBetCountText
Core.text.BalanceText = BalanceText
Core.text.NetPosition = NetPositionText
Core.text.FreespinsTotalWinText = FreespinsTotalWinText
Core.text.PayoutText = PayoutText
Core.text.PayoutTextCurrency = PayoutTextCurrency
Core.text.FreeBetLeft = FreeBetLeft
Core.text.FreeBetText = FreeBetText
Core.text.FreeBetWinText = FreeBetWinText
Core.text.WinText = WinText
Core.text.FreespinsTotalWinPopupText = FreespinsTotalWinPopupText
Core.text.LineWinText = LineWinText
Core.text.BitmapWinText = BitmapWinText
Core.text.BitmapBaseValue = BitmapBaseValue
Core.text.FreespinsTotalWinPopupTextCurrency = FreespinsTotalWinPopupTextCurrency
Core.text.LineWinTextCurrency = LineWinTextCurrency
Core.text.BalanceTextCurrency = BalanceTextCurrency
Core.text.BetTextCurrency = BetTextCurrency
Core.text.WinTextCurrency = WinTextCurrency

//buttons

Core.buttons.BetField = BetField
Core.buttons.AutoButton = AutoButton
Core.buttons.BetButton = BetButton
Core.buttons.GraphicsButton = GraphicsButton
Core.buttons.ImageButton = ImageButton
Core.buttons.RadioButton = RadioButton
Core.buttons.ReverseToggleButton = ReverseToggleButton
Core.buttons.ToggleButton = ToggleButton
Core.buttons.DecreaseAutoButton = DecreaseAutoButton
Core.buttons.DecreaseBetButton = DecreaseBetButton
Core.buttons.DecreasePageButton = DecreasePageButton
Core.buttons.IncreaseAutoButton = IncreaseAutoButton
Core.buttons.IncreaseBetButton = IncreaseBetButton
Core.buttons.IncreasePageButton = IncreasePageButton
Core.buttons.MaxBetButton = MaxBetButton
Core.buttons.NextHistoryButton = NextHistoryButton
Core.buttons.PrevHistoryButton = PrevHistoryButton
Core.buttons.SpinButton = SpinButton
Core.buttons.SpinSwipeButton = SpinSwipeButton
Core.buttons.PopupButton = makePopupButton

// display

Core.display.AnimationSpine = makeAnimationSpine
Core.display.LogoSpine = makeLogoSpine
Core.display.NoiseGraphics = NoiseGraphics
Core.display.BonusMultiplierSpine = BonusMultiplierSpine
Core.display.BonusMultiplier = BonusMultiplierSpine
Core.display.CascadeMultiplierSpine = makeCascadeMultiplierSpine
Core.display.BookAnimation = BookAnimationContainer
Core.display.BookFsReel = BookFsReel
Core.display.OverReelAnimation = OverReelAnimation
Core.display.TriggerSpine = makeTriggerSpine
Core.display.ReplaceTriggerSpine = makeReplaceTriggerSpine
Core.display.WinSpine = WinSpine
Core.display.AutoCarousel = AutoCarousel
Core.display.BetCarousel = BetCarousel
Core.display.BookSymbol = BookSymbol
Core.display.BuyBetCarousel = BuyBetCarousel
Core.display.PageCarousel = PageCarousel
Core.display.ExplosionReel = ExplosionReel
Core.display.FoodReel = HorizontalReel
Core.display.Reel = BaseReel
Core.display.CascadeReel = CascadeReel
Core.display.OverSymbolReel = OverSymbolReel
Core.display.VolcanReel = SlideReel
Core.display.Container = makeContainer
Core.display.Graphics = makeGraphics
Core.display.Mask = makeGraphics
Core.display.LinesContainer = makeContainer
Core.display.BonusImage = BonusImage
Core.display.ChoiceImage = ChoiceImage
Core.display.Image = Image
Core.display.NineSlicePlane = NineSlicePlane
Core.display.Particle = Particle
Core.display.BonusAnimation = BonusAnimation
Core.display.BonusNameSpine = BonusNameSpine
Core.display.BonusTwoAnimation = BonusTwoAnimation
Core.display.GambleSpine = GambleSpine
Core.display.ChooseSpinePopup = ChooseSpinePopup
Core.display.TransitionAnimation = TransitionAnimation
Core.display.VideoContainer = VideoContainer
Core.display.BaseLottery = BaseLottery
Core.display.VolcanComete = Image
Core.display.Loader = Image
Core.display.SymbolValuePopup = SymbolValuePopup
Core.display.CascadeWinBox = CascadeWinBox

//win

Core.win.WinParticle = WinParticle
Core.win.BigWinCounter = BigWinCounter
Core.win.BigWinTitle = BigWinTitle
Core.win.SingleWinParticle = SingleWinParticle
Core.win.ParticleSignals = ParticleSignals
